import { useState, useEffect, useRef, useContext } from "react";
import ReactDOM from "react-dom";
import styles from "./NewProfileModal.module.css";
import { Urls } from "../../../Urls";
import { isMobile } from "../../../Constants";
import TransporterDetailsBody from "../../TransporterClientScreen/TransporterDetailsBody";
import { useMixPanelForTracking } from "../../../utils/TrackMixPanel";
import { MyCompanyProfileContext } from "../../../MyCompanyProfileContext";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";


const NewProfileModal = ({
  isOpen,
  onClose,
  transporter_id,
  transporter_name,
  transporter_list = [],
}) => {
  const [selectedTransporter, setSelectedTransporter] = useState({
    id: transporter_id,
    name: transporter_name,
  });
  const [visible, setVisible] = useState(false);
  const mainRef = useRef(null);
  const navRef = useRef(null);
  const scrollTimerRef = useRef();
  const transporterBtnRefs = useRef({});
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { userDetails } = useContext(UserApiContext);
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData,
  );

  const beginScroll = (dir) => {
    scrollHorizontally(dir);
    scrollTimerRef.current = setInterval(() => scrollHorizontally(dir), 80);
  };

  const stopScroll = () => clearInterval(scrollTimerRef.current);

  const handleTransporterClick = (transporter) => {
    setSelectedTransporter({
      id: transporter.transporter_id,
      name: transporter.transporter_name,
    });

    mainRef?.current?.scrollTo({ top: 0, behavior: "instant" });

    const btnEl = transporterBtnRefs.current[transporter.transporter_id];
    if (btnEl) {
      btnEl.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };

  const scrollHorizontally = (dir = "left", amount = 300) => {
    if (!navRef.current) return;
    navRef.current.scrollBy({
      left: dir === "left" ? -amount : amount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (isOpen && transporter_id) {
      setSelectedTransporter({ id: transporter_id, name: transporter_name });
    }
  }, [isOpen, transporter_id, transporter_name]);

  // Animate open
  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      TrackMixPanel({
        ModuleName: "Transporter Profile",
        ScreenName: "Transporter Profile",
        Data: `Transporter ID: ${selectedTransporter.id}, Transporter Name: ${selectedTransporter.name}`,
        Definition: "User has visited Transporter profile screen",
      });

    } else {
      const timeout = setTimeout(() => setVisible(false), 200);
      return () => clearTimeout(timeout);
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!visible) return null;

  return ReactDOM.createPortal(
    <div
      className={`${styles.pm_overlay} ${isOpen ? styles.fade_in : styles.fade_out
        }`}
    >
      <div className={styles.pm_modal}>
        <header className={styles.pm_header}>
          <div className="d-flex align-items-center">
            {!isMobile() && (
              <img
                className="pr-2"
                width="93"
                height="36"
                src={Urls.LorriLogoLogin}
                alt="logo"
              />
            )}
            <div className={`${styles.pm_title} font-weight-bold pt-1 pl-2`}>
              Transporter Profile: {selectedTransporter.name}
            </div>
          </div>
          <button className="btn btn-sm btn-secondary" onClick={onClose}>
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </header>

        <main className={styles.pm_main} ref={mainRef}>
          <TransporterDetailsBody
            transporter_id={selectedTransporter.id}
            from="modal"
          />
        </main>

        {true && (
          <div className={styles.transporterNavWrapper}>
            <button
              className={`${styles.scrollBtn} ${styles.scrollLeft}`}
              onMouseDown={() => beginScroll("left")}
              onMouseUp={stopScroll}
              onMouseLeave={stopScroll}
              onTouchStart={() => beginScroll("left")}
              onTouchEnd={stopScroll}
            >
              <i className="fa fa-caret-left" aria-hidden="true"></i>
            </button>
            <nav className={styles.transporterNav} ref={navRef}>
              {(transporter_list.length > 0 ? transporter_list : [{ transporter_id: selectedTransporter.id, transporter_name: selectedTransporter.name }]).map((transporter) => (
                <button
                  key={transporter.transporter_id}
                  ref={(el) =>
                  (transporterBtnRefs.current[transporter.transporter_id] =
                    el)
                  }
                  className={`${styles.navItem} ${transporter.transporter_id === selectedTransporter.id
                    ? styles.activeNavItem
                    : ""
                    }`}
                  title={transporter.transporter_name}
                  onClick={() => handleTransporterClick(transporter)}
                >
                  {transporter.transporter_name.length > 20
                    ? transporter.transporter_name.slice(0, 17) + "..."
                    : transporter.transporter_name}
                </button>
              ))}
            </nav>
            <button
              className={`${styles.scrollBtn} ${styles.scrollRight}`}
              onMouseDown={() => beginScroll("right")}
              onMouseUp={stopScroll}
              onMouseLeave={stopScroll}
              onTouchStart={() => beginScroll("right")}
              onTouchEnd={stopScroll}
            >
              <i className="fa fa-caret-right" aria-hidden="true"></i>
            </button>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default NewProfileModal;
